import { createSlice } from "@reduxjs/toolkit";

export const audioSlice = createSlice({
  name: "audio",
  initialState: {
    url: null,
    isPlaying: false,
    shouldReset: false,
  },
  reducers: {
    setAudioUrl: (state, action) => {
      state.url = action.payload;
    },
    play: (state) => {
      state.isPlaying = true;
    },
    pause: (state) => {
      state.isPlaying = false;
    },
    toggle: (state) => {
      state.isPlaying = !state.isPlaying;
    },
    resetAudioPosition(state) {
      state.shouldReset = true;
    },
    clearResetFlag(state) {
      state.shouldReset = false;
    }
  },
});

export const audioActions = audioSlice.actions;

export default audioSlice.reducer;